import { observer } from 'mobx-react';
import { AntSelectEditableTagProps, AntSelectValue } from 'controls/react/ant/ant-select/types';
import React, { useCallback, useState } from 'react';
import { reactNodeToText } from 'controls/react/ant/ant-select/utils/reactNodeToText';
import { SpaceHighlighter } from 'controls/ant/ant-select/components/space-highlighter/spaceHighlighter';
import { EditOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { AntTag } from 'controls/react/ant/ant-select/antSelect';

export const EditableTag = observer(<VT extends AntSelectValue>(props: AntSelectEditableTagProps<VT>) => {
	const [editMode, setEditMode] = useState(false);

	const setValue = useCallback((e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>) => {
		setEditMode(false);
		props.onLabelEdit?.(props.value, 'value' in e.target ? e.target.value.trim() : null);
	}, []);

	const preventPropagationToParent = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
		//ant select control removes tag on backspace
		//enter forces all tags list to be opened, we dont need it
		if (e.key == 'Backspace' || e.key == 'Enter') {
			//backspace or enter
			e.stopPropagation();
		}
	}, []);

	const tooltip = props.tooltip ? props.tooltip : props.removable ? '' : props.nonRemovableMessage;

	const defaultValue = reactNodeToText(props.label);

	return (
		<div onClick={(e) => e.stopPropagation()}>
			{!editMode && (
				<AntTag
					className={props.extra.className}
					style={props.extra.style}
					title={tooltip}
					onClose={props.onClose}
					closable={props.removable !== undefined ? props.removable : true}
				>
					<SpaceHighlighter>{props.label}</SpaceHighlighter>
					{props.editable && (
						<EditOutlined
							onClick={() => {
								setEditMode(true);
							}}
						/>
					)}
				</AntTag>
			)}
			{editMode && (
				<Input
					size="small"
					defaultValue={defaultValue}
					allowClear={true}
					autoFocus={true}
					onKeyDown={preventPropagationToParent}
					onBlur={(e) => setValue(e)}
					onPressEnter={(e) => setValue(e)}
					onMouseDown={(e) => e.stopPropagation()} //changing position in input by clicking would not work without that
					style={{ width: '100px' }}
				/>
			)}
		</div>
	);
});
